// Сгенерировано developer_artifacts/scripts/buildFieldFlagArt.py: где слой лежит в кадре
export const FIELD_FLAG_LAYER_TRIMS = {
  cloth: {x: 126, y: 91, width: 258, height: 164},
  cloth_light: {x: 146, y: 91, width: 232, height: 164},
  cloth_contour: {x: 117, y: 82, width: 275, height: 182},
  cloth_glow: {x: 83, y: 48, width: 343, height: 250},
  cloth_shadow: {x: 112, y: 80, width: 292, height: 202},
  pole: {x: 99, y: 61, width: 70, height: 263},
  pole_contour: {x: 91, y: 52, width: 87, height: 281},
  pole_glow: {x: 57, y: 18, width: 155, height: 349},
  pole_shadow: {x: 92, y: 52, width: 96, height: 290},
};
